"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react");

function r() {
  return (r = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];

      for (var t in n) {
        Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var n = "💡 react-cool-dimensions: the browser doesn't support Resize Observer, please use polyfill: https://github.com/wellyshen/react-cool-dimensions#resizeobserver-polyfill",
    t = "💡 react-cool-dimensions: the browser doesn't support border-box size, fallback to content-box size. Please see: https://github.com/wellyshen/react-cool-dimensions#border-box-size-measurement";
exports.borderBoxWarn = t, exports.default = function (o) {
  var u = void 0 === o ? {} : o,
      i = u.ref,
      c = u.useBorderBoxSize,
      s = void 0 !== c && c,
      a = u.breakpoints,
      l = u.updateOnBreakpointChange,
      f = void 0 !== l && l,
      p = u.shouldUpdate,
      h = u.onResize,
      b = u.polyfill,
      d = e.useState({
    currentBreakpoint: "",
    width: 0,
    height: 0
  }),
      v = d[0],
      w = d[1],
      k = e.useRef({}),
      y = e.useRef(),
      B = e.useRef(null),
      z = e.useRef(null),
      R = e.useRef(null),
      g = e.useRef(!1),
      x = e.useRef(null),
      O = e.useRef(null == x ? void 0 : x.current);
  O = i || O, e.useEffect(function () {
    h && (z.current = h);
  }, [h]), e.useEffect(function () {
    p && (R.current = p);
  }, [p]);
  var m = e.useCallback(function (e) {
    e && (O.current = e), B.current && O.current && B.current.observe(O.current);
  }, [O]),
      S = e.useCallback(function () {
    B.current && B.current.disconnect();
  }, []);
  return e.useEffect(function () {
    return O.current ? "ResizeObserver" in window && "ResizeObserverEntry" in window || b ? (B.current = new (window.ResizeObserver || b)(function (e) {
      var r = e[0],
          n = r.contentBoxSize,
          o = r.borderBoxSize,
          u = r.contentRect,
          i = n;
      s && (o ? i = o : g.current || (console.warn(t), g.current = !0));
      var c = (i = Array.isArray(i) ? i[0] : i) ? i.inlineSize : u.width,
          l = i ? i.blockSize : u.height;

      if (c !== k.current.width || l !== k.current.height) {
        k.current = {
          width: c,
          height: l
        };
        var p,
            h,
            b,
            d,
            v = {
          currentBreakpoint: "",
          width: c,
          height: l,
          entry: r,
          observe: m,
          unobserve: S
        };
        a ? (v.currentBreakpoint = (p = a, h = c, b = "", d = -1, Object.keys(p).forEach(function (e) {
          var r = p[e];
          h >= r && r > d && (b = e, d = r);
        }), b), v.currentBreakpoint !== y.current && (z.current && z.current(v), y.current = v.currentBreakpoint)) : z.current && z.current(v);
        var B = {
          currentBreakpoint: v.currentBreakpoint,
          width: c,
          height: l,
          entry: r
        };
        R.current && !R.current(B) || (!R.current && a && f ? w(function (e) {
          return e.currentBreakpoint !== B.currentBreakpoint ? B : e;
        }) : w(B));
      }
    }), m(), function () {
      return S();
    }) : (console.error(n), function () {
      return null;
    }) : function () {
      return null;
    };
  }, [JSON.stringify(a), s, m, S, f]), r({
    ref: O
  }, v, {
    observe: m,
    unobserve: S
  });
}, exports.observerErr = n;